import 'Assets/css/app.min.css'
import 'Assets/css/cn/app.min.css'

require("Assets/js/cn/app.min.js");
require("Assets/js/footer.js");